export default __webpack_public_path__ + "static/media/netcarbs@2x.6fffa804.jpg";